/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Indicator/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Indicator({
  children,
  viewPath = "/DesignSystem/TimelineEvent/CustomResource/Content/Indicator"
  
}) {
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="Indicator.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Indicator.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-1-1wiWS0': dtColorsNeutral200}}
 className={`views-block ${styles.Vertical1}`}
/>
<div
  data-testid="Indicator.Vertical:2"
  data-view-path={viewPath}
 style={{'--h-2-1wiWS0': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--w-3-1wiWS0': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--btlr-4-1wiWS0': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--btrr-5-1wiWS0': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--bblr-6-1wiWS0': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--bbrr-7-1wiWS0': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--bc-1-1wiWS0': dtColorsWhite,'--bw-8-1wiWS0': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical2}`}
/>
</div>
{children}
</React.Fragment>)
}